module.exports = __webpack_public_path__ + "static/media/dummy.6a4ff553.jpg";